/**
 * Full Bleed Banner. Laying the groundwork for custom cover and contain functionality.
 */
(function($) {
    const fullBleedBanner   = '.wp-block-neat-full-bleed-banner';
    const bannerImg         = '> img';
    const loadedClass       = 'is-loaded';
    let $fullBleedBanner    = $(fullBleedBanner);

    function scaleBanners() {
        $fullBleedBanner.each(function() {
            let $container = $(this);
            let $image = $(this).find(bannerImg);
            if( $container.hasClass('contain') ) {
                scaleImageContainer($container, $image, true);
            } else {
                scaleImageContainer($container, $image);
            }
            $container.addClass(loadedClass);
        });
    }

    function parallaxBanners() {
        $fullBleedBanner.each(function() {
            let $image = $(this).find(bannerImg);
            if( !$(this).hasClass('is-parallax') ) return;
            if( elementInView($(this)) == 'view' ) {
                parallaxImageContainer($(this), $image);
            }
        });
    }

    $(window).on('load', function() {
        scaleBanners();
        parallaxBanners();
    });

    $(window).on('resize', function() {
        scaleBanners();
    });

    $(window).on('scroll', function() {
        parallaxBanners();
    });

})(jQuery);